import TablePagination from '../ui-control/TablePagination';

const ListingCardPagination = ({
  dataLimit,
  setDataLimit,
  totalCount,
  totalPages,
  currentPage,
  setCurrentPage,
}) => {
  const startEntry = totalCount === 0 ? 0 : ((currentPage - 1) * dataLimit) + 1;
  const endEntry = Math.min(currentPage * dataLimit, totalCount);

  return (
    <TablePagination
      startEntry={startEntry}
      endEntry={endEntry}
      totalCount={totalCount}
      pageSize={dataLimit}
      onPageSizeChange={setDataLimit}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      summaryGapClass="gap-6"
    />
  );
};

export default ListingCardPagination;